import { DatePicker } from "./DatePicker";
import { useEffect, useState } from "react";

const RangeDatePicker = ({
  onValueChange,
  defaultValue = { from: null, to: null },
  orientation = "vertical",
}) => {
  const [dateRange, setDateRange] = useState(defaultValue);

  const onFromValueChangeHandler = (from) => {
    setDateRange({ ...dateRange, from: from });
  };

  const onToValueChangeHandler = (to) => {
    setDateRange({ ...dateRange, to: to });
  };

  const onValueChangeHandler = () => {
    if (dateRange.from && dateRange.to) {
      onValueChange(dateRange);
    }
  };

  useEffect(() => {
    onValueChangeHandler();
  }, [dateRange]);

  return (
    <div
      className={`flex ${
        orientation === "vertical" ? "flex-col gap-y-1" : "flex-row gap-x-1"
      }`}
    >
      <DatePicker
        defaultValue={dateRange?.from}
        onValueChange={onFromValueChangeHandler}
      />
      <DatePicker
        defaultValue={dateRange?.to}
        onValueChange={onToValueChangeHandler}
      />
    </div>
  );
};

export default RangeDatePicker;
